import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af67b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-estimate-li_content" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "task-time-estimate-li_buttons"
}

import { computed, PropType, ref } from 'vue';
import { PerformerEstimatedModel } from '../../models';
import { InformationCircleIcon, PencilSquareIcon } from 'tir-style-system/icons/outline';
import {
  TirPmIconView,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmTooltipElement,
} from 'tir-components';
import TaskTimeEstimateRemove from './task-time-estimate-remove.vue';
import TaskTimeEstimateInput from './task-time-estimate-input.vue';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-estimate-li',
  props: {
  /**Оценка по исполнителю */
  performerEstimate: { type: Object as PropType<PerformerEstimatedModel>, required: true },
  /**Id задачи */
  taskId: { type: Number },
  /**Редактирование */
  isEditTime: { type: Boolean },
},
  emits: ["removePerformer"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Открыт ли поповер с подтверждением удаления */
const isPopoverOpen = ref();

/**Классы компонента */
const componentClasses = computed(() => ({
  'with-popover': isPopoverOpen.value,
}));
/**Инициалы */
const computedNameFoto = computed(() => {
  return (
    props.performerEstimate.FirstName?.[0]?.toUpperCase() +
    props.performerEstimate.LastName?.[0]?.toUpperCase()
  );
});
/**Оценка */
const estimate = computed(() => props.performerEstimate?.Estimate?.toFixed(2) || 0);
/**Текст оценки времени */
const estimateText = computed(() => (estimate.value ? `${estimate.value}ч.` : '?'));
/**Время установки оценки */
const upsertTime = computed(() => {
  const date = props.performerEstimate.DateUpsert;
  if (!date || !estimate.value) return '';

  const day = addZero(date.getDate());
  const month = addZero(date.getMonth() + 1);
  const year = addZero(date.getFullYear(), 4);
  return `${day}.${month}.${year}`;
});

/**Добавление нуля */
const addZero = (n: number, numberLength: number = 2) => {
  const number = String(n);
  return number.length == numberLength ? number : `${'0'.repeat(numberLength - 1)}${number}`;
};
/**Удаление приглашения */
const onRemoveInvite = () => {
  emit('removePerformer', props.performerEstimate.Id);
};
/**Установка значения поля isPopoverOpen */
const setIsPopoverOpen = (open: boolean) => {
  isPopoverOpen.value = open;
};
/**Редактирование оценки */
const toggleEdit = (isEdit: boolean) => {
  props.performerEstimate.IsEdit = isEdit;
};
/**Обновление оценки */
const upsertEstimate = (estimate: number) => {
  props.performerEstimate.Estimate = estimate;
  props.performerEstimate.DateUpsert = new Date();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["task-time-estimate-li", componentClasses.value])
  }, [
    (__props.performerEstimate.IsEdit)
      ? (_openBlock(), _createBlock(TaskTimeEstimateInput, {
          key: 0,
          taskId: __props.taskId,
          performerEstimate: __props.performerEstimate,
          estimate: __props.performerEstimate.Estimate,
          onUpsert: upsertEstimate,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (toggleEdit(false)))
        }, null, 8, ["taskId", "performerEstimate", "estimate"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TirPmTooltipElement), null, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.performerEstimate.LastName) + " " + _toDisplayString(__props.performerEstimate.FirstName) + " " + _toDisplayString(__props.performerEstimate.MiddleName), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(TirPmIconView), {
                  size: 24,
                  isRounded: "",
                  isBordered: false,
                  colorCode: __props.performerEstimate.AvatarColor,
                  imageLoadUrl: __props.performerEstimate.Foto
                }, {
                  mainSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(computedNameFoto.value), 1)
                  ]),
                  _: 1
                }, 8, ["colorCode", "imageLoadUrl"])
              ]),
              _: 1
            }),
            _createElementVNode("span", {
              textContent: _toDisplayString(estimateText.value),
              class: "task-time-estimate-li_content-text"
            }, null, 8, _hoisted_2),
            (upsertTime.value)
              ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(upsertTime.value), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(InformationCircleIcon), { class: "task-time-estimate-li_content_info" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (__props.isEditTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (estimate.value)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleEdit(true)))
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PencilSquareIcon))
                      ]),
                      _: 1
                    }, 8, ["size", "variant"]))
                  : _createCommentVNode("", true),
                _createVNode(TaskTimeEstimateRemove, {
                  taskId: __props.taskId,
                  performerId: __props.performerEstimate.Id,
                  onOnRemove: onRemoveInvite,
                  onOpen: _cache[2] || (_cache[2] = ($event: any) => (setIsPopoverOpen(true))),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (setIsPopoverOpen(false)))
                }, null, 8, ["taskId", "performerId"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}
}

})